import { render, staticRenderFns } from "./displayFields.vue?vue&type=template&id=a2da5852&scoped=true&"
import script from "./displayFields.vue?vue&type=script&lang=js&"
export * from "./displayFields.vue?vue&type=script&lang=js&"
import style0 from "./displayFields.vue?vue&type=style&index=0&id=a2da5852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2da5852",
  null
  
)

export default component.exports